import unity from '../img/Unity.png';


function Outro() {
    return (    
    <div className="Outro">
        <p>
        <img src={unity} alt="Made with unity" width="100" height="35"/>
        <br/>
          <h3>Future Plans</h3>
          Virtual reality games have the potential for extremely immersive storytelling, 
          and there are many other genres and elements of games that I enjoy that I would like to incorporate into my own games, 
          such as stealth, puzzle solving, and trying to make interesting stories.
          <br/>
          Unity makes it easy to make a wide range of unique games, 2D, 3D, and VR. I would use it for my own personal projects.
          I would also like to expand my portfolio as a web developer by continuing to work on projects for clients.
        </p>
      </div>
    );
}

export default Outro;